import { generatePath } from "react-router-dom";

import { RoutePath } from "./routePath";

/**
 * General path constants shared across feature boundaries.
 * Covers beneficiary, disclosures, fulfillment, support, and dev config.
 */
export const RouteTemplates = {
  disclosure: "/disclosure/:slug",
  ineligible: "/ineligible/:reason",
  fulfillment: "/fulfillment/:action/:policyId",
  fulfillmentNoPolicy: "/fulfillment/:action",
  beneficiary: "/beneficiary/:lineOfBusiness",
} as const;

export const appPaths = {
  beneficiary: RoutePath(RouteTemplates.beneficiary),
  disclosure: RoutePath(RouteTemplates.disclosure),
  // Optional :reason — explicit arrow function (RoutePath requires all params)
  ineligible: (params?: { reason: string }) =>
    params ? generatePath(RouteTemplates.ineligible, params) : "/ineligible",
  // Optional :policyId — explicit arrow function
  fulfillment: (params: { action: string; policyId?: string }) =>
    params.policyId
      ? generatePath(RouteTemplates.fulfillment, params as { action: string; policyId: string })
      : generatePath(RouteTemplates.fulfillmentNoPolicy, params),
  customerSupport: "/customer-support",
  config: "/config",
  home: "/",
};
